import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createSuper";
import { ValueWithRandom } from "../../ValueWithRandom";
export var OrbitRotation = /*#__PURE__*/function (_ValueWithRandom) {
  _inherits(OrbitRotation, _ValueWithRandom);
  var _super = _createSuper(OrbitRotation);
  function OrbitRotation() {
    var _this;
    _classCallCheck(this, OrbitRotation);
    _this = _super.call(this);
    _this.value = 45;
    _this.random.enable = false;
    _this.random.minimumValue = 0;
    return _this;
  }
  _createClass(OrbitRotation, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      _get(_getPrototypeOf(OrbitRotation.prototype), "load", this).call(this, data);
    }
  }]);
  return OrbitRotation;
}(ValueWithRandom);